// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2basm","alertIcon":"ConfirmModal_alertIcon__2DFOM"};